var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6422_36434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6429 10.8571H10.8571V17.6429C10.8571 18.3893 10.2464 19 9.5 19C8.75357 19 8.14286 18.3893 8.14286 17.6429V10.8571H1.35714C0.610714 10.8571 0 10.2464 0 9.5C0 8.75357 0.610714 8.14286 1.35714 8.14286H8.14286V1.35714C8.14286 0.610714 8.75357 0 9.5 0C10.2464 0 10.8571 0.610714 10.8571 1.35714V8.14286H17.6429C18.3893 8.14286 19 8.75357 19 9.5C19 10.2464 18.3893 10.8571 17.6429 10.8571Z",
    fill: "#507CF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6422_36434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.e863537a5971e3decb6f2095ffde0eea.svg";
export { ForwardRef as ReactComponent };